/**
 * Функция отправки данных по метрике
 */
function sendEventMetrics (event, params) {
  const getManufacturer = localStorage.getItem('isManufacturer'),
        isManufacturer  = getManufacturer === 'true',
        uuid = localStorage.getItem('UUID'),
        yandexUid = localStorage.getItem('_ym_uid')
  // console.log({ event, uuid, yandexUid })
  if (process.env.NODE_ENV !== 'development') {
    try {
      // exchange
      // channel_name
      // web.event.custom  это у реббита queue -> routing key
      // action - message в Rabbit
      const data = new FormData
      data.append('arr', JSON.stringify({ event, uuid, yandexUid }))
      data.append('action', event)

      axios.post('/logevent', data).then(res => !res.data.status ? console.error(res.data.message) : null )
    } catch (e) {
      console.error(e)
    }
    try {
      ym(40131035, 'reachGoal', event)
      ym(40131035, 'userParams', {
        manufacturer: isManufacturer,
        designer: !isManufacturer
      })
    } catch (e) {
      console.error(e)
    }
    try {
      dataLayer.push({
        event: 'EVENT2GA',
        eventCategory: event.split('_')[0],
        eventAction: event.split('_')[1],
        eventLabel: '',
        eventValue: '',
      })
    } catch (e) {
      console.error(e)
    }
    try {
      fbq('trackCustom', event)
    } catch (e) {
      console.error(e)
    }
  }
}

function addListenerOnElement (el, binding = null) {
  el.addEventListener('mousedown', e => {
    e.stopPropagation()
    if (e.button !== 2) {
      try {
        if (binding && typeof binding.value !== 'string') {
          console.error(`Внутри директивы v-metrics ожидается string, получено ${typeof binding.value}`)
          return
        }
        const data = binding.value.split(',')
        sendEventMetrics(data[0].trim(), data[1] ? data[1].trim() : '')
      } catch (e) {
        console.error('Ошибка синтаксиса. При передаче данных event и params требутся разделять запятой.')
      }
    }
  })
}

export const metricDirective =  {
  inserted (el, binding) {
    addListenerOnElement(el, binding)
  }
}
